export default function PrimaryButton({ className = '', disabled, children, ...props }) {
    return (
        <button
            {...props}
            className={
                `inline-flex items-center px-3 py-2 bg-primary-blue-500 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-wider hover:bg-primary-blue-700 focus:bg-primary-blue-700 active:bg-primary-blue-900 focus:outline-none focus:ring-2 focus:ring-primary-blue-500 focus:ring-offset-2 transition ease-in-out duration-150 shadow-md ${
                    disabled && 'opacity-25'
                } ` + className
            }
            disabled={disabled}
        >
            {children}
        </button>
    );
}
